module.exports = __webpack_public_path__ + "img/in-screen-front.33291688.png";